export default {
  en: {
    unclaimedSupplier: 'Unclaimed',
    addSupplier: 'Add supplier',
    answer: {
      answered: 'Answered',
      unanswered: 'Unanswered',
      answeredClient: 'You answered',
      last_modified: 'Last modified {0}',
    },
    info: {
      country: 'Country',
      companyNumber: 'Company number',
      notProvided: 'Not provided',
      sector: 'Sector',
      tradingNames: 'Trading names',
      unclaimed: "This information hasn't been verified by the supplier",
      answersSelected: '{n} answer selected | {n} answers selected',
      incompleteAssessment: 'This supplier has not yet completed their assessment.',
      incompleteAssessmentClient: 'It looks like you have not yet completed your assessment.',
      incompleteAssessmentNote: 'You will be notified when they do so.',
      incompleteAssessmentNoteClient: 'You will be able to see your compliance when you do so.',
      noFilteredAnswers: 'No answers match the filters applied',
      noFilteredAnswersNote: 'Change the filters to show some answers',
      lastUpdatedTooltip: 'The last time this supplier updated an answer.',
      lastUpdatedAt: 'Last updated: {date}',
      unclaimedNotConnectedTitle: 'No one from this supplier is active on Risk Ledger yet',
      unclaimedNotConnectedDesc:
        'They will be included in your list of suppliers but you may miss some data',
      claimedNotConnectedTitle:
        'Add this supplier to request access to their assessment and add notes, risks and documents',
      claimedNotConnectedDesc: "We'll let you know once the supplier has accepted your request",
      unverified: 'Unclaimed',
      addsupplier: 'Add supplier',
      trialBanner: {
        title: "You've reached the limit of suppliers in the free trial.",
        description: 'Book a demo to learn about our paid plans with unlimited suppliers.',
        cta: 'Book a demo',
      },
    },
    stats: {
      compliance: 'Compliance',
      score: 'Score',
      complianceScore: 'Compliance score',
      controls: 'Controls',
      overrides: 'Overrides',
      compliant: 'Compliant',
      nonComplianceApplied: 'Non-compliances',
      exemptionsApplied: 'Exemptions',
      remediations: 'Remediations',
      remediationRequests: 'Requests',
      remediationResponses: 'Responses',
      risks: 'Risks',
      complete: 'Complete',
      openRisks: 'Open',
      closedRisks: 'Closed',
      myReview: 'Compliance overview',
      networkSignals: 'Community signals',
      approvalRating: 'Approval rating',
      allCommunities: 'all your communities',
      controlSignals: 'Signal on controls | Signals on controls',
      risksAndSignals: 'Risks & signals',
      openRisksIn: 'Open risk | Open risks',
      closedRisksIn: 'Closed risk | Closed risks',
      communityApproved: '{x} out of {n} peer in {community} | {x} out of {n} peers in {community}',
      communityApprovedPercentage: '{percentage}%',
      approvalRate: 'Approval rate',
      communityConcentrationRisk: 'Potential concentration risk',
      communityConcentrationRiskDescription: 'Connections',
      communityNoConnections:
        'Your peers from this community have not yet connected to this supplier',
      viewHere: 'View here',
      new: 'New',
      findings: {
        title: 'Monitoring findings',
        monitoring: 'Monitoring',
        total: 'Latest findings',
        bySeverityTitle: 'Latest findings by severity',
        assetCountTitle: 'Number of active assets',
        assetCountTitleShort: 'No. of assets',
        diveDeepTitle: 'Want to deep dive into findings?',
        diveDeepDesc:
          'Gain extra external data points for this supplier without the need for assessments',
        noIssues: 'No issues\nfound',
        severity: {
          critical: 'Critical',
          high: 'High',
          medium: 'Medium',
          low: 'Low',
          info: 'Info',
        },
        modal: {
          monitoring: 'Monitoring',
          title: "Deep dive into {name}'s scanned assets",
          description:
            'As a supplier within your network, we identified assets and scanned them. This pre-analysis provides foundational insights into their presence within your supplier network',
          keyBenefits: 'Key benefits',
          benefit1Key: 'Complete Asset Visibility:',
          benefit1:
            '{0} Gain a consolidated view of all scanned assets within your network, providing a comprehensive inventory.',
          benefit2Key: 'Proactive Risk Mitigation:',
          benefit2:
            '{0} Identify potential security infractions and vulnerabilities early, enabling timely intervention before they become critical threats.',
          benefit3Key: 'Flexible Scan Capabilities:',
          benefit3:
            '{0} Leverage a diverse array of scan types to tailor assessments to specific asset types and security requirements, ensuring thorough coverage.',
          requestDemoNow: 'Request a demo now to enable External Monitoring.',
          requestADemo: 'Request a demo now',
          notNow: 'Not now',
          successToast: 'We have received your interest and we will be in contact soon',
          errorToast: 'Failed registering interest. Try again soon.',
        },
      },
      policyImpact: 'Policies impacting this supplier',
      nonCompliantCount: '{count} non-compliant',
      policyNotes: 'Policy notes',
      policyCategorisation: 'Categorisation linked to this policy',
      byDomain: {
        nonCompliant: '{count} non-compliant',
        notScored: 'Not Scored',
      },
    },
    policy: {
      required: 'Policy requires',
      clientRequired: 'Client requires',
      notRequired: 'Control not required',
      yes: 'Yes',
      no: 'No',
      orMore: '{0} or more',
      orLess: '{0} or less',
      policyRequirementsTitle: 'Policy requirements',
      noPolicyRequirements: 'No policy requirements',
      requiredByPoliciesTooltip:
        'Not required by any policies | Required by one policy | Required by {n} policies',
      requiresShort: 'Requires',
    },
    buttons: {
      cancel: 'Cancel',
      confirm: 'Confirm',
      editAnswer: 'Edit answer',
      answer: 'Answer',
      actions: 'Actions',
    },
    tags: {
      criticality: 'Criticality',
      confidentiality: 'Confidentiality',
      pii: 'PII',
      set_tag_failed: 'Failed to set tag',
    },
    overrideReason: {
      nonComplianceTitle: 'Non-compliance applied',
      exemptionAppliedTitle: 'Exemption applied',
      nonComplianceDesc:
        'Applying non-compliance will override the compliance status of this answer, making it non-compliant until removed.',
      exemptionDesc:
        'Applying exemption will override the compliance status of this answer, making it compliant until removed.',
      nonComplianceDescMulti:
        'Applying non-compliance will override the compliance status of these answers, making them non-compliant until removed.',
      exemptionDescMulti:
        'Applying exemptions will override the compliance status of these answers, making them compliant until removed.',
      title: 'Please provide a reason:',
      nonCompliancePlaceholder: 'This answer is non-compliant because...',
      exemptionPlaceholder: 'This answer is compliant because...',
      defaultError: 'Could not apply override. Please try again.',
      buttons: {
        applyNonCompliance: 'Apply non-compliance',
        applyExemption: 'Apply exemption',
        apply: 'Apply',
        remove: 'Remove',
        applyToSelected: 'Apply to selected',
      },
    },
    overview: {
      maybeInaccurate:
        "This supplier's compliance score might not be accurate as they have yet to fill out the new controls you have required",
      status: 'Status',
      client: 'Client',
      policiesApplied: 'Policies applied',
      policiesNoneAppliedTitle: 'No policies applied',
      policiesNoneAppliedText:
        'Add categorisations or labels to this supplier to apply relevant policies',
      policiesNoneActiveTitle: 'No active policies',
      policiesNoneActiveText:
        'Any policies set will take effect once the supplier claims their profile and accepts the connection. You can view and modify them at any time.',
      complianceByDomain: 'Compliance by domain',
      errorClient: 'Failed to load client. Please try again.',
      errorSupplier: 'Failed to load supplier. Please try again.',
      clientBanner: "You're currently viewing your compliance against {name}'s policies.",
      assignEmpty: 'Nobody yet.',
      assignYourself: 'Assign yourself',
      assignUsers: 'Select users...',
      cancel: 'Cancel',
      save: 'Save',
      assignedTo: 'Assigned to',
      errorAssignment: 'There was an error assigning users',
      assessmentStatus: 'Assessment status',
      openRisk: 'Open risk',
      viewClientNetwork: 'View in network map',
      viewCommunityNetwork: 'View in community map',
      noPoliciesApplied1: '{org} have not yet applied their policies to your profile..',
      noPoliciesApplied2:
        "Once policies have been applied, you'll be able to see a breakdown of your compliance by domain and question.",
      noOneActiveTitle: 'No one from this supplier is active on Risk Ledger yet',
      noOneActiveText: 'They will be included in your list of suppliers but you may miss some data',
      noOneActiveCta: 'Invite to Risk Ledger',
      noOneActivePendingInviteTitle: "We've invited this supplier to join Risk Ledger",
      noOneActivePendingInviteText:
        'After {email} accepts your invite they will be able to complete their assessment',
      activePendingConnectionRequestTitle: '{name} has requested access to this supplier',
      activePendingConnectionRequestText:
        'After {orgName} accepts the request you will be able to access their full profile',
      activeNoConnectionRequestTitle:
        'Add this supplier to request access to their assessment and add notes, risks and documents',
      activeNoConnectionRequestDesc:
        "We'll let you know once the supplier has accepted your request",
      basicReview: 'Basic review',
      privateNotesTitle: 'Private notes & files',
      privateNotesCta: 'Add private note',
      openRisks: 'No open risks | 1 open risk | {n} open risks',
      requestAccess: 'Request access',
      errorConnectionPrivacy: 'Failed to update connection privacy. Please try again.',
      privateConnectionOffDescription:
        'Your connection to {name} is visible to other organisations on the network and communities.',
      privateConnectionOnDescription:
        'Your connection to {name} is not visible to other organisations on the network and communities.',
      privateConnection: 'Private connection',
    },
    removeConnection: {
      supplier: 'Remove supplier',
      client: 'Remove client',
      message: 'Before continuing, confirm if you would like to remove {name} as a {type}.',
      defaultError: 'Failed to remove connection. Please try again.',
      reasonPlaceholder: 'Removal reason...',
      reasonQuestion: 'Why are you removing this connection?',
      messageWarning: 'This message will be sent to {name}.',
    },
    assessment: {
      compliant: 'Compliant',
      nonCompliant: 'Not compliant',
      notScored: 'Not scored',
      required: 'Required',
      notRequired: 'Not required',
      openRisks: 'Open risks',
      noOpenRisks: 'No open risks',
      searchControls: 'Search controls and answers...',
      sortBy: 'Sort by',
      filterBy: 'Filter by',
      clearFilters: 'Reset',
      domainControl: 'Domain / control',
      lastModified: 'Last modified',
      description: 'Description',
      exemptionApplied: 'Exemption applied',
      nonComplianceApplied: 'Non-compliance applied',
      remediationPending: 'Remediation pending',
      remediationResponded: 'Remediation responded',
      defaultError: 'Failed to load assessment. Please try again.',
      filter: {
        title: 'Keyboard shortcuts',
        text: 'Use the up and down keys to move between answers.',
        sections: {
          requirement: 'Requirement',
          compliance: 'Compliance',
          override: 'Overrides',
          remediation: 'Remediation',
          risk: 'Risk',
          product: 'Product',
          deprecated: 'Deprecation',
          certification: 'Certification',
          domain: 'Domain',
        },
      },
      clientBanner: "You're currently viewing your assessment against {name}'s requirements.",
      showOOSControlsTemplate: '{0} out of scope. Show anyway',
      showOOSControls: '{n} controls | {n} control | {n} controls',
      hideOOSControlsTemplate: 'Showing {0} out of scope. Hide',
      hideOOSControls: '{n} controls | {n} control | {n} controls',
      outOfScope: 'Out of scope',
      notApplicable: 'N/A',
      domainOutOfScope: 'Domain is out of scope.<br/>To bring into scope, answer must be yes.',
      domainInScope: 'Domain is in-scope.',
      deprecated: 'Deprecated',
      nonDeprecated: 'Non deprecated',
      deprecatedControl: 'This control is deprecated.',
      inprogress: 'In progress - {percent}%',
      overdueBannerTitle: '{0} has not completed a re-assessment within the last 6 months.',
      overdueBannerSubtitle:
        'Their answers may be out of date. You can prompt them to complete their re-assessment by starting a new discussion.',
      openDiscussion: 'Open a discussion',
      unconfirmedAnswer: {
        title: 'Unconfirmed answer.',
        description:
          'This control question has been updated since you last reviewed your answer. Please confirm it is still accurate.',
        descriptionClient:
          'This control has been modified since the supplier last reviewed their answer. It may no longer be accurate.',
      },
      noPoliciesApplied:
        "You're currently awaiting review and {org} have yet to apply their policies to your profile. Once they've been applied, you'll be able to see a breakdown of your compliance by domain and question.",
      communityRemediations:
        '{n} open remediation in communities | {n} open remediations in communities',
      communityRisks: '{n} open risk in communities | {n} open risks in communities',
      communityRemediationsFilter: 'Community remediations',
      communityRisksFilter: 'Community risks',
      productAnswerLabel: 'In relation to {product}',
      controlDescription: 'Control description',
    },
    tooltips: {
      approval: 'Approval status',
      evidence: 'Evidence uploaded',
      answer: 'Answer',
      scopingAnswer: 'Scoping question answer',
      unanswered: "This control hasn't been answered",
      exemption: 'Exemption applied',
      noncompliance: 'Noncompliance applied',
      remediation: 'Remediation requested',
      remediationResponse: 'Remediation request responded',
      privateNotes: 'Has private notes',
      outOfScope: "This control's domain is out of scope",
      notApplicable: 'This control is not applicable',
      unconfirmed: 'This control has been updated and is unconfirmed',
      communityControlSignals: 'Community signals',
    },
    notes: {
      visibleLabel: 'Only visible to {0}',
      placeholder: 'Enter notes about this supplier...',
      title: 'Private notes',
      save: 'Save',
      defaultError: 'Could not save private note. Please try again.',
      successToast: 'Successfully saved private note',
    },
    remediation: {
      popoverContent: {
        title: 'Please provide a reason and deadline:',
        desc: 'Requesting remediation will send a notification to the supplier, asking them to remediate their answer to this control.',
        button: 'Send request',
        placeholder: 'This answer needs remediating because...',
        deadlinePlaceholder: 'Deadline',
        defaultError: 'Could not set remediation. Please try again.',
      },
      requestButton: 'Request remediation',
      requested: {
        titleSupplier: 'Remediation requested',
        titleClient: 'Remediation requested by client',
        cancel: 'Cancel',
        deadline: 'Deadline',
        markDone: 'Mark as done',
      },
      response: {
        titleSupplier: 'Remediated by supplier',
        titleClient: 'Remediated by you',
        accept: 'Accept',
        rerequest: 'Reject',
      },
    },
    discussion: {
      discussion: 'Discussion',
    },
    tabs: {
      overview: 'Overview',
      assessment: 'Assessment',
      externalMonitoring: 'External monitoring',
      evidence: 'Evidence',
      discussions: 'Discussions',
      activityFeed: 'Activity',
      about: 'About',
      notes: 'Private notes',
      emergingThreats: 'Emerging Threats',
      risks: 'Risks',
      activityAndDiscussion: 'Activity & discussion',
    },
    export: {
      downloadAssessment: 'Export report',
      error: 'Could not download assessment. Please try again.',
      asPdf: 'Export as PDF',
      asCsv: 'Export as CSV',
      csv: {
        domainLetter: 'Domain letter',
        domainName: 'Domain name',
        controlNumber: 'Control number',
        controlQuestion: 'Control question',
        answer: 'Answer',
        answerNotes: 'Answer notes',
        requirement: 'Requirement',
        compliant: 'Compliant',
        complianceStatus: 'Compliance status',
        overrideApplied: 'Override applied',
        clientNotes: 'Client notes',
        evidence: 'Evidence',
        lastModified: 'Last modified',
        remediation: 'Remediation',
        no: 'NO',
        yes: 'YES',
        notRequired: 'NOT REQUIRED',
        requires: 'REQUIRES {0}',
        exemption: 'EXEMPTION - {0}',
        nonCompliance: 'NON COMPLIANCE - {0}',
        atMax: '{0} OR LESS',
        atLeast: '{0} OR MORE',
        outOfScope: 'OUT OF SCOPE',
        unanswered: 'UNANSWERED',
        notApplicable: 'NOT APPLICABLE',
        awaitingResponse: 'AWAITING RESPONSE',
        awaitingReview: 'AWAITING REVIEW',
        compliantScore: 'COMPLIANT',
        notCompliantScore: 'NOT COMPLIANT',
        notScored: 'NOT SCORED',
      },
      pdfModal: {
        title: 'Export PDF report',
        subtitle:
          "Select which fields you would like to include in the report below, and then click 'Export PDF'.",
        cancel: 'Cancel',
        export: 'Export PDF',
        tags: 'Criticality, confidentiality & PII',
        labels: 'Custom labels',
        compliance: 'Compliance',
        remediations: 'Remediation requests',
        requirements: 'Policy requirements',
        overrides: 'Overrides',
        clientAnswerNotes: 'Client answer notes',
        privateNotes: 'Private notes',
        status: 'Approval status',
        newPagePerDomain: 'Page break between domains',
        evidence: 'Evidence',
        customProperties: 'Custom properties',
        risks: 'Risks',
      },
      pdf: {
        title: 'Supplier assessment report',
        criticality: 'Criticality',
        confidentiality: 'Confidentiality',
        pii: 'PII',
        labels: 'Labels',
        date: 'Date',
        dateFormat: 'yyyy/MM/dd',
        compliance: 'Compliance',
        remediations: 'Remediations',
        pendingRemediations: '{0} pending',
        status: 'Status',
        scopingQuestion: 'Scoping question:',
        scopingNotes: 'Scoping notes:',
        answerResult: 'Answer: {0}',
        yes: 'Yes',
        no: 'No',
        question: 'Question',
        answer: 'Answer',
        requires: 'Requires',
        notRequired: 'Not required',
        orMore: 'or more',
        orLess: 'or less',
        outOfScope: 'Out of scope',
        na: 'N/A',
        unanswered: 'Unanswered',
        compliant: 'Compliant',
        nonCompliant: 'Non-compliant',
        numberNonCompliant: '# Non-compliant controls:',
        answerNotes: 'Answer notes:',
        clientNotes: 'Client notes:',
        remediation: 'Remediation:',
        override: 'Override:',
        exemption: 'Exemption applied: {0}\nCreated on: {1}',
        nonCompliance: 'Non compliance applied: {0}\nCreated on: {1}',
        lastModified: 'Last modified:',
        rl: 'Risk Ledger',
        remediationContent: '{0}\nDeadline: {1}',
        evidence: 'Evidence:',
        approvalExpiresAt: 'Approval expires',
        reassessmentNextDueAt: 'Reassessment due',
        exemptions: 'Exemptions applied',
        nonCompliances: 'Non compliances applied',
        privateNotes: 'Private notes',
        createdAt: 'Date',
        includedEvidence: 'Included evidence',
        note: 'Note',
        customProperties: 'Custom properties',
      },
    },
    evidence: {
      entity: 'Evidence',
      downloadAll: 'Download selected ({count})',
      placeholder: {
        title: 'No evidence uploaded',
        subtitle: 'This organisation has not uploaded any evidence files',
        errorTitle: 'Supplier evidence',
        errorDescription: 'Failed fetching supplier evidence',
      },
      filter: {
        domainControl: 'Domain / control',
        lastUploaded: 'Last uploaded',
        sortBy: 'Sort by',
        filterBy: 'Filter by',
        clearFilters: 'Reset',
        searchEvidence: 'Search evidence...',
        noEvidenceMatch: 'No evidence matches the filters applied',
        noEvidenceMatchSub: 'Change the filters to show some evidence',
      },
      filterAttributes: {
        name: 'Name',
        extension: 'File extension',
        size: 'File size',
        domain: 'Domain',
      },
      control: 'Control',
      uploaded: 'Uploaded at',
      expiredOn: 'Expired on {date}',
      expiresOn: 'Expires on {date}',
      tableColumns: {
        name: 'Name',
        extension: 'File extension',
        size: 'File size',
        uploadedAt: 'Upload date',
        controlDomain: 'Control / domain',
        attachments: 'Attachments',
      },
      emergingThreatQuestion: 'Emerging Threat q.{index}',
    },
    sharedConnections: {
      button: '1 total peer | {n} total peers',
      title: '{count} peer | {count} peers',
      dateAdded: 'Date connected',
      openRisks: 'Open risks',
      confidentiality: 'Confidentiality',
      criticality: 'Criticality',
      pii: 'PII',
      yourReview: 'Your review',
    },
    userLabel: {
      team: 'Team',
      role: 'Role',
      restrictedSupplierAccess: 'They can only access their assigned suppliers.',
      restrictedSupplierAccessSelf: 'You can only access your assigned suppliers.',
    },
    relevantPosts: {
      button: '1 community post | {n} community posts',
    },
    connect: {
      title: 'Connect with {name}',
      description:
        'To help {orgName} verify your connection request, include the name of your account manager or another identifier such as an account number in the message below.',
      noContactDescription:
        "We know that sometimes you won't have a named contact of a supplier. If that is the case, please select the reason below so that we can better assist you.",
      sentTitle: 'Connection sent',
      sentDescription: "You've requested access to their full profile & assessment.",
      sentContent: '{email} has received an email about your request.',
      nameLabel: 'Contact name',
      namePlaceholder: 'Jane doe',
      emailLabel: 'Contact email address',
      emailPlaceholder: "jane{'@'}example.com",
      messageLabel: 'Message',
      messagePlaceholder: 'Hi jane - { currentOrgName } would like to connect with you to...',
      contactMode: {
        question: 'How would you like to send this connection request?',
        provide: 'Send with a contact',
        noContact: 'Send without a contact',
      },
      noContactReasonLabel: "Reason you don't have supplier contact details",
      noContactReasonInfo:
        "By including contact details, you are 64% more likely to get a reply. This gets the right person's attention faster, and helps our team follow up on your behalf.",
      emailRequired: 'Enter the contact email address.',
      noContactReasonRequired: 'Select a reason before sending.',
      cancel: 'Cancel',
      connect: 'Connect',
      viewBasicProfile: 'View basic profile',
      primerEmail: {
        desc: 'I confirm a {primerEmail} has been sent to this supplier.',
        link: 'Primer email',
      },
      messageAutofillShort:
        'Hi - {senderOrg} would like to connect with you to review your Risk Ledger assessment. Thanks, {senderUser} ({senderEmail})',
      messageAutofillLong:
        'Hi - {senderOrg} would like to connect with you to review your Risk Ledger assessment. We emailed {contact} on [date] letting them know of this request. Thanks, {senderUser} ({senderEmail})',
      addDate: 'Please add the date of contact or modify the message.',
      connectionIDError: 'An error occurred. Refresh the page and try again.',
      categoriseTitle: 'How would you categorise this supplier?',
      categoriseDescription:
        'Categorising your supplier now will make sure that when they fill in their security assessment, they will be assessed against your current policies.',
      finish: 'Finish',
    },
    suppliers: {
      title: 'Add & invite supplier',
      name: 'Supplier name',
      namePlaceholder: 'Supplier name',
      website: 'Website',
      websitePlaceholder: 'https://example.com',
      companyNumber: 'Registered company number',
      companyNumberPlaceholder: 'eg. 10203040',
      industry: 'Sector',
      industryPlaceholder: 'Select sector',
      country: 'Registered country',
      countryPlaceholder: 'Select country',
      moreInfo: 'This will need to be verified by the supplier and may change after they sign up.',
      contactInfo:
        "If you have a contact at this supplier, we'll invite them to the Risk Ledger platform to complete an assessment.",
      contactName: 'Contact name',
      contactNamePlaceholder: 'Jane doe',
      contactEmail: 'Contact email address',
      contactEmailPlaceholder: "jane{'@'}example.com",
      primerEmail: {
        desc: 'I confirm a {primerEmail} has been sent to this supplier.',
        link: 'Primer email',
      },
      nextStep: 'Next step',
      addAndInvite: 'Add & invite supplier',
      skipInvite: 'Skip invite for now',
      step1: 'Set supplier information',
      step2: 'Invite to Risk Ledger',
      connectionExistsError:
        'The contact email is already in use by another supplier you are connected to.',
      inviteError: 'Failed to add supplier. Please try again.',
      orgExists: 'The supplier with given name and location already exists',
    },
    connectionProducts: {
      title: {
        client: 'Products',
        supplier: 'Products this client uses',
      },
      noProducts: 'No products have been added by this supplier',
      loading: 'Loading...',
      error: 'Failed to load products. Please try again.',
      modal: {
        client: {
          title: 'Change the products you see from this supplier',
          description:
            'Keeping the products you use accurate from this supplier will help you see accurate answers to your assessment questions. ',
          label: 'Products or services from this supplier you use',
          noProducts: 'No products have been added by this supplier',
          noMoreProducts: 'No more products have been added by this supplier',
        },
        supplier: {
          title: 'Change the products this client is connected to',
          description:
            'It is important to make sure that you give the client answers relating to the services they use. Please make sure below that they receive the correct answers by settings the answers they see. ',
          label: 'Products or services this client uses',
          noProducts: 'No products found',
        },
        emptyState: 'No products selected',
        addProducts: 'Add more products',
      },
    },
    levelRequired: {
      title: 'Framework size required',
      error: 'Failed to update framework config. Please try again.',
    },
    addOnsRequired: {
      title: 'Add-ons required',
      none: 'None',
    },
    editFrameworkConfigModal: {
      introTitle: 'What information do you want from this supplier?',
      onlyAddOns: {
        introBody:
          'These add-on domains would be additional to the main set of controls. These domains are optional and should only be selected if they are relevant to the supplier you are onboarding',
      },
      onlyLevels: {
        introBody:
          'Setting the framework size a supplier will need to fill out for you will determine which controls you will be able to evaluate them against',
      },
      levelsAndAddOns: {
        introBody:
          'Setting the framework size and add-ons you want a supplier to fill out will determine which controls you will be able to review them against',
      },
      addOnsTitle: 'Add-on domains',
      addOnsDescription:
        "Select any additional domains you'd like this supplier to fill out above and beyond the core compliance framework.",
      levelsTitle: 'Framework size',
      levelsDescription: 'Set the size of framework you want the supplier to fill out.',
      productAnswersTitle: 'Product answers',
      optional: '(optional)',
      productAnswersDescription:
        'This supplier has added product-specific answers to some questions. Select any products you use from this supplier.',
    },
    categoriseSupplierModal: {
      modalTitle: 'What information do you want the supplier to complete?',
      modalDescription:
        'Setting the framework size and add-ons you want a supplier to fill out will determine which controls you will be able to review them against',
      levelTitle: 'Framework size',
      levelDescription: 'Set the size of framework you want the supplier to fill out.',
      addOnsTitle: 'Add-on domains',
      optional: '(optional)',
      addOnsDescription:
        "Select any additional domains you'd like this supplier to fill out above and beyond the core compliance framework.",
    },
    editAddOnsModal: {
      introTitle: 'What add-on domains do you want the supplier to complete?',
      introBody: 'Select the add-on domains you would like to review this supplier against',
      optionsTitle: 'Add-on domains',
      confirmTitle: 'Are you sure you want to make this change?',
      addTitle: 'Adding an add-on will:',
      add1: 'Notify the supplier to complete the newly required questions.',
      add2: "Immediately affect the supplier's compliance score, based on the add-on's controls, regardless of whether they have answered the questions.",
      removeTitle: 'Removing an add-on will:',
      remove1: 'Close any risks that are associated to the controls within this add-on.',
      remove2: 'Archive any discussions that are associated to the controls within this add-on.',
      remove3: 'Close any remediations that are associated to the controls within this add-on.',
    },
    editLevelsModal: {
      introTitle: 'What framework size do you want the supplier to complete?',
      introBody: 'Select the framework size you would like to review this supplier against',
      optionsTitle: 'Framework size',
      smallerTitle: 'This will:',
      smaller1: 'Close any risks associated with controls not present in this framework.',
      smaller2: 'Archive any discussions related to controls not present in this framework.',
      smaller3: 'Close any remediations linked to controls not present in this framework.',
      largerTitle: 'Requiring the larger framework will:',
      larger1: 'Notify the supplier to complete the new framework size.',
      larger2:
        "Immediately affect the supplier's compliance score, regardless of whether they have answered the questions.",
      confirmTitle: 'Are you sure you want to make this change?',
    },
  },
};
